const makeInitialState = kamAssigned => {
  return {
    distributorProfile: kamAssigned || null
  };
};

export default makeInitialState;
